import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { useTranslation } from "react-i18next";

interface ToShare {
  url?: string;
  title: string;
  socials?: {
    twitter?: string;
    linkedin?: string;
  };
}

const Share: React.FC = (props: { toShare: ToShare }) => {
  const { toShare } = props;
  const title = encodeURI(toShare.title);
  const twitterURL = toShare.socials?.twitter || "https://thecookies.agency";
  const linkedinURL = toShare.socials?.linkedin || "https://thecookies.agency";
  const { t } = useTranslation("global");

  return (
    <div className={"m-share"}>
      <ul className={"m-social-list"}>
        <li className={"m-social-list__item "}>
          <a
            href={`https://twitter.com/intent/tweet?url=${twitterURL}${toShare.url}&text=${title} by @Thecookies_agcy`}
            target="_blank"
            rel="nofollow noopener noreferrer"
          >
            <StaticImage
              alt={t("icono Twitter")}
              src={"../../../assets/icons/twitter.svg"}
              width={25}
            />
          </a>
        </li>
        <li className={"m-social-list__item"}>
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${linkedinURL}`}
            target="_blank"
            rel="nofollow noreferrer"
          >
            <StaticImage
              alt={t("icono Linkedin")}
              src={"../../../assets/icons/linkedin.svg"}
              width={25}
            />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Share;
